import { Link, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <Navbar />
      <main className="flex flex-col items-center justify-center min-h-[calc(100vh-64px)] bg-background-50 text-center px-4">
        <div className="relative mb-8">
          <span className="text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none leading-none">
            404
          </span>
          <div className="absolute inset-0 flex items-center justify-center">
            <i className="ri-error-warning-line text-6xl md:text-8xl text-accent-400/60"></i>
          </div>
        </div>

        <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
          Page Not Found
        </h1>
        <p className="text-sm md:text-base text-foreground-500 max-w-md mb-2 leading-relaxed">
          The page you are looking for does not exist or has been moved. Check the URL or return to the homepage to continue exploring Hipobuy Spreadsheet resources.
        </p>
        <p className="text-xs text-foreground-400 font-mono mb-8">
          {location.pathname}
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-home-line"></i>
            Back to Home
          </Link>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3 border-2 border-foreground-200 text-foreground-700 rounded-full text-sm font-semibold hover:border-foreground-400 transition-colors whitespace-nowrap"
          >
            Visit Main Store
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-5 text-xs text-foreground-400">
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-500 text-sm"></i> Updated Resources
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-500 text-sm"></i> 14 Categories
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-500 text-sm"></i> Safety Verified
          </span>
        </div>
      </main>
      <Footer />
    </>
  );
}